import { trpc } from '@/lib/trpc';

const useValidate = () => {
	const { mutate, isPending, error } = trpc.user.validate.useMutation();

	return {
		validate: mutate,
		validateLoading: isPending,
		validateError: error,
	};
};

export default useValidate;
